module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "md8": "",
      "lg7": ""
    }
  }, [_c('v-card', {
    staticClass: "py-4"
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-3": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-3": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.companies,
      "label": _vm.$lang.actions.selectCompany,
      "item-text": "name",
      "item-value": "id",
      "required": "",
      "readonly": _vm.isEdit,
      "loading": _vm.companyLoading,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompany)); }]
    },
    model: {
      value: (_vm.appResource.companyId),
      callback: function($$v) {
        _vm.$set(_vm.appResource, "companyId", $$v)
      },
      expression: "appResource.companyId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.name,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingAppResName)); }]
    },
    model: {
      value: (_vm.appResource.name),
      callback: function($$v) {
        _vm.$set(_vm.appResource, "name", $$v)
      },
      expression: "appResource.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.appResourceTypes,
      "label": _vm.$lang.actions.selectAppResType,
      "readonly": _vm.isEdit,
      "required": "",
      "rules": [function () { return _vm.appResource.type.length > 0 || ("" + (_vm.$lang.errorsAppResType)); }]
    },
    model: {
      value: (_vm.appResource.type),
      callback: function($$v) {
        _vm.$set(_vm.appResource, "type", $$v)
      },
      expression: "appResource.type"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.subscriptionModels,
      "label": _vm.$lang.actions.selectAppResSubModel,
      "required": "",
      "rules": [function () { return _vm.appResource.subscriptionModel.length > 0 || ("" + (_vm.$lang.errors.missingAppResSubModel)); }]
    },
    model: {
      value: (_vm.appResource.subscriptionModel),
      callback: function($$v) {
        _vm.$set(_vm.appResource, "subscriptionModel", $$v)
      },
      expression: "appResource.subscriptionModel"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [(_vm.isEdit && _vm.createdOn) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3",
    attrs: {
      "label": _vm.$lang.labels.created,
      "readonly": ""
    },
    model: {
      value: (_vm.createdOn),
      callback: function($$v) {
        _vm.createdOn = $$v
      },
      expression: "createdOn"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isEdit && _vm.modifiedOn) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3",
    attrs: {
      "label": _vm.$lang.labels.modified,
      "readonly": ""
    },
    model: {
      value: (_vm.modifiedOn),
      callback: function($$v) {
        _vm.modifiedOn = $$v
      },
      expression: "modifiedOn"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2 px-4",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-content-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "ml-0",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'appResources'
        })
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v("\n          " + _vm._s(_vm.$lang.actions.close) + "\n        ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-0",
    attrs: {
      "disabled": !_vm.valid
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n          " + _vm._s(_vm.isEdit ? _vm.$lang.actions.update : _vm.$lang.actions.create) + "\n        ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0265a682","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/appResource/AppResourceDetails.vue
// module id = 379
// module chunks = 35